import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../../query/query-ids'
import { addRecentItem } from '@/api/users'
import type { RecentItemActionEnum } from '~~/src/types/user'

export function useAddRecentItemMutation() {
  const queryClient = useQueryClient()

  return useMutation<
    Awaited<ReturnType<typeof addRecentItem>>,
    Error,
    {
      dataId: string
      userId: string
      action: RecentItemActionEnum
    }
  >({
    mutationKey: ['add-as-recent'],
    mutationFn: async ({ action, dataId, userId }) => await addRecentItem(userId, dataId, action),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [TanStackQueryIds.RECENT_ELEMENTAL],
      })
    },
  })
}
